import mitt from 'mitt'

// 创建事件总线实例
export const eventBus = mitt()

// 导出常用方法
export const { emit: globalEmit, on, off } = eventBus

// 定义事件类型常量
export const EVENT_TYPES = {
    RECOMMEND_CLICK: 'recommend-click',
    MESSAGE_SEND: 'message-send',
    CHAT_CLEAR: 'chat-clear',
    CHAT_SCROLL_BOTTOM: 'chat-scroll-bottom',
    CHAT_HISTORY_LOADED: 'chat-history-loaded',
    RE_ANSWER: 're-answer',
    QUIZME: 'quizMe',
    CHAT_ABORT_REQUEST: 'chat-abort-request',
    CHAT_DEMO_CLICK: 'chat-demo-click',
    SEND_IMAGE: 'send-image',
    UPLOAD_FILES: 'upload-files',
    GO_LOGIN: 'go-login',
    RELOAD_ROUTER: 'reload-router',
    LOGIN_SUCCESS: 'login-success',
    EXPERT_HISTORY_UPDATED: 'expert-history-updated'
} as const
